"use strict";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Cookie = require('cookies-js');

var get = require('lodash/get');

var storage = require('@flowio/storage');

var config = require('./config');

var getCookieDomain = require('./get-cookie-domain');

function isTemporary(options) {
  return !!get(options, 'useSessionStorage');
}

function setCookie(sess, options, domain) {
  var cookieOptions = {};

  if (domain) {
    cookieOptions.domain = domain;
  }

  if (isTemporary(options)) {
    Cookie.set(config.COOKIE_SESSION_TEMPORARY_KEY, sess.id, cookieOptions);
  } else {
    Cookie.set(config.COOKIE_SESSION_KEY, sess.id, _objectSpread(_objectSpread({}, cookieOptions), {}, {
      expires: config.YEAR_SECONDS
    }));
  }
}

function persistCookie(sess, options) {
  var domain = getCookieDomain();
  setCookie(sess, options, domain); // There is currently an issue with our getCookieDomain code where if the site
  // is on a top level domain with multiple periods like something.co.uk,
  // the domain will actually be set to the TLD which cannot be done so no cookie will be set
  // If a cookie wasn't set when we check, we try to make the cookie
  // again without a domain this time, which will default it to the current full domain

  if (!Cookie.get(config.COOKIE_SESSION_KEY) && !Cookie.get(config.COOKIE_SESSION_TEMPORARY_KEY)) {
    setCookie(sess, options);
  }
}

function persistStorage(sess, options) {
  if (isTemporary(options)) {
    storage.session.set('session', sess);
  } else {
    storage.local.set('session', sess);
  }
}

function persistMemory(sess) {
  storage.memory.set('session', sess);
}

function cleanCookie() {
  Cookie.expire(config.COOKIE_SESSION_KEY);
}
/**
 * Persists session to Storage. Returns if persist was successful or not.
 *
 * @param {Object} sess The full session object from the API.
 * @param {Object} options
 * @param {Object} options.useSessionStorage - store session in session storage / cookie
 * @return {Boolean}     Whether storing the session was successful or not.
 */


function persistSession(sess, options) {
  cleanCookie();
  persistCookie(sess, options);

  try {
    persistStorage(sess, options);
  } catch (error) {
    persistMemory(sess);
  }
}

module.exports = persistSession;


//////////////////
// WEBPACK FOOTER
// ./~/@flowio/session/lib/persist-session.js
// module id = 116
// module chunks = 0 1